import { render } from "./DbsBeforeUnlockCaution.vue?vue&type=template&id=63fc1154&scoped=true"
import script from "./DbsBeforeUnlockCaution.vue?vue&type=script&lang=js"
export * from "./DbsBeforeUnlockCaution.vue?vue&type=script&lang=js"

import "./DbsBeforeUnlockCaution.vue?vue&type=style&index=0&id=63fc1154&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63fc1154"

export default script